import React, { useEffect, useContext, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { PrairiButton, StartupProfile, InvestorProfile, TextButton } from "@peterfosso/prairi-components";
import { getFunctions, httpsCallable } from "firebase/functions"
import { navBarContext, authContext } from "./context/context";
import {
  query,
  collection,
  db,
  where,
  getDocs,
  getDoc,
  doc,
  Timestamp,
  updateDoc,
  addDoc,
  setDoc
} from "../firebase/firebaseApp";
import { updateLatestActions } from "../utils";

const ApproveUser = () => {
  const { navBarHeight } = useContext(navBarContext);
  let { docId } = useParams();
  const [userData, setUserData] = useState(null);
  const [name, setName] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const [approved, setApproved] = useState(false)
  const [pendingApproval, setPendingApproval] = useState(false)
  const [showProfile, setShowProfile] = useState(false)
  const { currentUser } = useContext(authContext);
  const { uid } = currentUser || {};
  let navigate = useNavigate();
  const isAdminUser = currentUser && currentUser.uid === "A3Go76mJaLT2GeqHsxlYZRCOWur2";

  const getDataFromDb = async () => {
    try {
      const userRef = doc(db, "users", docId);
      const userSnap = await getDoc(userRef);
      
      if (userSnap.exists()) {
        const userData = userSnap.data();
        setUserData(userData);
        setDataFetched(true);
        return { userData, userId: docId };
      } else {
        console.log("No user document found");
      }
    } catch (error) {
      console.log(error);
    }
  };

const handleApproveUser = async () => {
  await updateDoc(doc(db, "users", docId), {
    active: true,
    pendingApproval: false
  });
}

useEffect(() => {
  if (userData && userData.pendingApproval) {
    setPendingApproval(true);
  }
  if (userData && userData.approved) {
    setApproved(true);
  }
}, [userData]);


  const handleApprove = async () => {
    if (currentUser && isAdminUser) {
      await handleApproveUser();
      setApproved(true)
      setPendingApproval(false)
    } else {
      navigate("/404");
    }
  };

  useEffect(() => {
      getDataFromDb();
  }, [docId, isAdminUser, currentUser, navigate]);

if (isAdminUser){
  return (
    <div className={`w-full`} style={{ marginTop: navBarHeight + 4 }}>
      {dataFetched && (
        <div className="flex flex-col justify-center items-center mt-4">
          { <div className="flex flex-col justify-center items-center">
            <div className="text-center">In case you need to contact the user, you can do it at <a className="text-blue-500 underline" href={`mailto:${userData.email}`}>{userData.email}</a></div>
            {userData.category === "startup" && <StartupProfile startup={userData} basic />}
            {userData.category === "investor" && <InvestorProfile investor={userData}  />}
            <PrairiButton click={handleApprove} size="lg" border="green" label={`Approve ${userData.contactName}`} />
          </div>}

        {approved && <div className="flex flex-col justify-center items-center">
          <h1 className="my-4 text-center text-lg md:text-xl">
            You have approved {userData.contactName}
          </h1>
          <TextButton click={() => setShowProfile(true)} size="lg" border="green" label={`View profile`} />
          {showProfile && <StartupProfile startup={userData} basic />}
        </div>}
        </div>
      )}
    </div>
  );
}
else{
  return(<>forbidden access</>)
  
}

};

export default ApproveUser;
